import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { addToCart } from '../store/slices/cartSlice';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { HTTP_STATUS } from '../utils/httpStatusCodes';
import { toast } from 'react-toastify';
import { getSessionId } from '../utils/sessionId';
import { getDisplayPrice } from '../utils/priceUtils';
import '../styles/compactCards.css';

const TakeawayMenuList = ({ category, onItemClick, onCartChange, orderType, editOrderId, LoadDishesByDeals, currentCuisineId, onDealClick, soldOutIds, stockLevels, onAddRejected, onPendingAdd, onPendingSettle, onPendingFail, compactCards = false, hideAllergenIcons = false }) => {
  const [loadingKey, setLoadingKey] = useState(null);
  //const dispatch = useDispatch();
  //console.log('hello');
  console.log(category);
  //console.log('hello Task');
  if (!category) return null;
  console.log('hello Task 222222222');
  // Smaller cards ("Compact product cards" setting): only for a category where every item is an ordinary
  // product with one or two sizes. One item with three or more sizes, or a deal, keeps the whole category
  // on full-size cards so the rows of the grid stay even.
  const compact = !!compactCards && category.length > 0
    && category.every((d) => d.is_deal !== '1' && (d.serving_sizes || []).length <= 2);
  // On a compact card the size buttons and the pencil sit in one group so they stay together when they drop
  // to a second line under a long name; a full card has no group.
  const Controls = compact ? 'div' : React.Fragment;
  const controlsProps = compact ? { className: 'mProControls' } : {};
  // The same action as tapping that size's button.
  const chooseSize = (dish, size) => (
    dish.force_customization_popup ? onItemClick({ ...dish, size: size.id }) : handleAddToCart(dish, size)
  );
  // A compact card with a single size is tappable as a whole (nothing to choose). With two sizes the
  // person has to pick one, so only the size buttons act.
  const tappableSize = (dish) => (
    compact && !isSoldOut(dish) && (dish.serving_sizes || []).length === 1 ? dish.serving_sizes[0] : null
  );
  const onCardTap = (e, dish) => {
    if (e.target.closest('.mProSize, .mEditTrigger')) return; // those act on their own
    const size = tappableSize(dish);
    if (size) chooseSize(dish, size);
  };
  const editTrigger = (dish) => (
    <span className="mEditTrigger" onClick={() => !isSoldOut(dish) && onItemClick(dish)}>
      <svg width="20" height="20" className="editIcon">
        <use xlinkHref="./images/sprite.svg#iconEdit"></use>
      </svg>
    </span>
  );

  // Sold-out items stay on the menu but can't be ordered. The server refuses them too (this list
  // is cached and can be a minute behind), see onAddRejected below.
  const isSoldOut = (dish) => !!soldOutIds && soldOutIds.has(Number(dish.item_id));

  // Units left, only for stock-tracked products that are still on sale.
  const unitsLeft = (dish) => {
    const n = stockLevels ? stockLevels[Number(dish.item_id)] : undefined;
    return n === undefined || isSoldOut(dish) ? null : n;
  };

  const handleAddToCart = async (dish, size) => {
    const key = `${dish.item_id}_${size.id}`;
    // The row appears in the cart the moment the size is tapped (see useCart: addPendingRow), so there is
    // no waiting to guard against: a second tap on the same size is a second item. With the instant cart
    // switched off on this device (tempId null) it works as before - one add at a time per size.
    const unitPrice = Number(getDisplayPrice(size, orderType));
    const tempId = onPendingAdd && Number.isFinite(unitPrice)
      ? onPendingAdd({
          item_id: dish.item_id,
          item_name: dish.itemname,
          selected_size: size.title || size.abbreviation || '',
          qty: 1,
          unit_price: unitPrice,
          first_image_url: dish.image,
        })
      : null;
    if (!tempId) {
      if (loadingKey === key) return;
      setLoadingKey(key);
    }
    let placeholderHandled = false;
    //dispatch(addToCart({ item: dish, size }));
    try{
      const session_id = getSessionId(); //remeber to remove on order complete or logout
      // Call API to add item to cart
      const phone_order =  orderType == 'takeaway' || orderType == 'phone' ? 1 : 0;
      const payload = {
        id:dish.item_id,
        size_id: size.id,
         session_id:session_id ,
         phone_order: phone_order,
        selected_customer_id: 1
      }
      if (editOrderId) {
        payload.edit_order_id = editOrderId;
      }
      // With a row already shown (tempId) the call runs quietly: the full-screen loader would sit over the
      // cart and the menu for the whole round trip and cancel the point of showing the row at once.
      const response = await callAPI(apiUrls.ADD_TO_CART, {}, 'POST', payload, {}, {}, !tempId);
      //alert(response.status);
      // The API answers HTTP 200 with status 0 + a message when it refuses the add (e.g. the item
      // was sold out after this menu was loaded) - surface that instead of "Item added to cart".
      if (response.data?.status === 0) {
        if (tempId && onPendingFail) { onPendingFail(tempId); placeholderHandled = true; }
        toast.error(response.data.message || 'Could not add item to cart');
        if (onAddRejected) onAddRejected();
        return;
      }
      if(response.status === HTTP_STATUS.OK) {
        if (tempId && onPendingSettle) { onPendingSettle(tempId); placeholderHandled = true; }
        if (onCartChange) onCartChange(); // yahan call karo
        toast.success("Item added to cart");
        //alert("Item added to cart");
        let attempts = 0;
        const maxAttempts = 10;
        const interval = window.setInterval(() => {
          attempts += 1;
          // Prefer link that matches the product id (if deal maps to this product),
          // then prefer link that matches the current cuisine (hostUrl), else fallback to first link.
          const productSelector = `.addItemsCol ul li a[data-productid='${dish.item_id}']`;
          const hostSelector = currentCuisineId ? `.addItemsCol ul li a[data-hosturl='${currentCuisineId}']` : null;
          let targetLink = document.querySelector(productSelector) || (hostSelector ? document.querySelector(hostSelector) : null) || document.querySelector('.addItemsCol ul li a:first-of-type');

          if (targetLink) {
            window.clearInterval(interval);
            // Debug: log which link was matched and its dataset
            try {
              console.debug('Matched Add Item link', {
                outerHTML: targetLink.outerHTML,
                dataset: targetLink.dataset,
                productSelector,
                hostSelector,
              });
            } catch (e) {}

            const hostUrl = targetLink.dataset.hosturl;
            const sub_cat_in_logic = targetLink.dataset.subcat;
            const product_id = targetLink.dataset.productid;
            const size_id = targetLink.dataset.sizeid;
            if (typeof LoadDishesByDeals === 'function') {
              LoadDishesByDeals(hostUrl, sub_cat_in_logic, product_id, size_id);
            } else if (window && typeof window.LoadDishesByDeals === 'function') {
              window.LoadDishesByDeals(hostUrl, sub_cat_in_logic, product_id, size_id);
            } else {
              // fallback: click the link if no function available
              targetLink.click();
            }
          }
          if (attempts >= maxAttempts) {
            window.clearInterval(interval);
          }
        }, 1200);
        console.log("Dish details response:", response.data);//just for debugging will where to use
      }
    } catch (error) {
      console.error("Error fetching dish details:", error);
      toast.error("Failed to add item to cart");
    } finally {
      // whatever happened, a row that was shown for this add is never left behind
      if (tempId && !placeholderHandled && onPendingFail) onPendingFail(tempId);
      if (!tempId) setLoadingKey(null);
    }
  }

  return (
    <div className="tab-content" id="menuTabContent">
      <div
        className="tab-pane fade show active"
        id={`content-${category.category_slug}`}
        role="tabpanel"
        aria-labelledby={`tab-${category.category_slug}`}
        tabIndex="0"
      >
        <div className="row g-3">
          {(category || []).map((dish) => (
            (dish.is_deal !== '1') ? (
              <>
                <div className="col-md-6 col-xl-4" key={dish.item_id}>
                  <div className={`menuProCol${compact ? ' compact' : ''}${tappableSize(dish) ? ' tappable' : ''}${isSoldOut(dish) ? ' soldOut' : ''}`} onClick={(e) => onCardTap(e, dish)}>
                    <div className="mProTopCol">
                      <div className="mProTopRow">
                        <img src={dish.image} alt={dish.itemname} className="mProImg" />
                    <div className="mProName">{dish.itemname}</div>
                    {isSoldOut(dish) && <span className="soldOutBadge">Sold out</span>}
                    {unitsLeft(dish) !== null && (
                      <span className={`stockLeftBadge${unitsLeft(dish) <= 3 ? ' low' : ''}`}>{unitsLeft(dish)} left</span>
                    )}
                    {!compact && editTrigger(dish)}
                  </div>
                  <Controls {...controlsProps}>
                  <div className="mProSizes">
                    {(dish.serving_sizes || []).map((size) => {
                      const btnKey = `${dish.item_id}_${size.id}`;
                      const isLoading = loadingKey === btnKey;
                      return (
                        <button
                          className="mProSize"
                          key={size.id}
                          // With "Customisation Pop Up" set for this product - or for its category
                          // or sub-category, which the API folds into the same flag - the size pill
                          // opens the customisation dialog instead of dropping the item straight in
                          // the cart. The clicked size is passed through so the dialog opens on it.
                          onClick={() => chooseSize(dish, size)}
                          disabled={isLoading || isSoldOut(dish)}
                          style={isLoading ? { opacity: 0.6, pointerEvents: 'none' } : {}}
                        >
                          {isLoading ? (
                            <span className="sizeLbl" style={{ display: 'inline-block', width: 16, height: 16, border: '2px solid currentColor', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.6s linear infinite', verticalAlign: 'middle' }} />
                          ) : (
                            <span className="sizeLbl">
                              {size.abbreviation || (size.title ? size.title.slice(0, 3).toUpperCase() : '')}
                            </span>
                          )}
                          <span className="price"> ${getDisplayPrice(size, orderType)}</span>
                        </button>
                      );
                    })}
                  </div>
                  {compact && editTrigger(dish)}
                  </Controls>
                </div>
                {dish.is_dietary_icons_enabled !== false && !hideAllergenIcons && (
                <div className="mProBtmCol">
                  <div className="mProType">
                  {(dish.preferences_home_page || []).map((pref) => {
                    const isActive = pref.active === true || pref.active === 'true';
                    //alert(pref.active);
                    return (
                      <label title={pref.value}>
                        <input className='pref-checkbox' type="checkbox" value={pref.key} checked={isActive} readOnly />
                        <img
                          key={pref.key}
                          src={`/${pref.icon}`}
                          alt={pref.value}
                          className={`typeIcon${isActive ? ' ' : ''}`}
                          width="26"
                          height="26"
                          style={!isActive ? { filter: 'grayscale(1)' } : {}}
                        />
                      </label>
                    );
                  })}
                  </div>
                </div>
                )}
              </div>
            </div>
          </>) : (<>
            <div className="col-md-6 col-xl-4" key={dish.item_id}>
                  <div className={`menuProCol${isSoldOut(dish) ? ' soldOut' : ''}`}>
                    <div className="mProTopCol">
                      <div className="mProTopRow">
                        <img src={dish.image} alt={dish.itemname} className="mProImg" />
                    <div className="mProName">{dish.itemname}</div>
                    {isSoldOut(dish) && <span className="soldOutBadge">Sold out</span>}
                  </div>
                  <p>{dish.itemdetails}</p>
                    <p>{dish.highlighter}</p>
                  <div className="mProSizes">
                    {(dish.serving_sizes || []).map((size) => (
                      <button
                        className="mProSize"
                        key={size.id}
                        onClick={() => onDealClick && onDealClick(dish, size)}
                        disabled={isSoldOut(dish)}
                      >
                        <span className="price"> ${getDisplayPrice(size, orderType)}</span>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>)
          ))}
        </div>
      </div>
    </div>
  );
  };

  export default TakeawayMenuList;